import { createStore, useStore } from 'zustand';

type EventStoreQueueType = () => Promise<void> | void;

type EventStoreType = {
    isReady: boolean;
    queue: EventStoreQueueType[];
};

export const eventStore = createStore<EventStoreType>(() => ({
    isReady: false,
    queue: [],
}));

export const useIsEventsReady = () => useStore(eventStore, (state) => state.isReady);

export const useHasQueuedEvents = () => useStore(eventStore, (state) => state.queue.length > 0);

export const addToQueue = (fn: EventStoreQueueType) => {
    eventStore.setState({ queue: [...eventStore.getState().queue, fn] });
};

export const resetQueue = () => {
    eventStore.setState({ queue: [] });
};

export const setIsReady = (bool: boolean) => {
    eventStore.setState({ isReady: bool });
};
